import { useLoading } from '@toss/use-loading';
import { useTranslation } from 'next-i18next';
import { ZDialog } from '@/ui';
import { Button } from '@/ui_v3';
import { LoadingSpinner } from './LoadingSpinner';
interface Props {
  title: string;
  content?: string;
  shouldHideCancelButton?: boolean;
  cancelText?: string;
  confirmText?: string;
  open: boolean;
  onClose?: () => void;
  onConfirm?: () => Promise<unknown>;
}
export function ConfirmDialog(props: Props) {
  const {
    t
  } = useTranslation(['common']);
  const {
    title,
    content,
    shouldHideCancelButton,
    cancelText: cancelTextProp,
    confirmText: confirmTextProp,
    open,
    onClose,
    onConfirm
  } = props;
  const cancelText = cancelTextProp ?? t('common.confirmDialog.cancelText');
  const confirmText = confirmTextProp ?? t('common.confirmDialog.confirmText');
  const [isLoading, startLoading] = useLoading();
  return <ZDialog.Dialog maxWidth="320px" open={open} onClose={() => onClose?.()} data-sentry-element="unknown" data-sentry-component="ConfirmDialog" data-sentry-source-file="ConfirmDialog.tsx">
      <ZDialog.DialogOverlay data-sentry-element="unknown" data-sentry-source-file="ConfirmDialog.tsx" />
      <ZDialog.DialogPanel className="pt-2" data-sentry-element="unknown" data-sentry-source-file="ConfirmDialog.tsx">
        <ZDialog.DialogHeader className="text-heading-md-bold" data-sentry-element="unknown" data-sentry-source-file="ConfirmDialog.tsx">
          {title}
        </ZDialog.DialogHeader>
        <ZDialog.DialogContent className="!px-6 text-body-md-regular" data-sentry-element="unknown" data-sentry-source-file="ConfirmDialog.tsx">
          {content}
        </ZDialog.DialogContent>
        <ZDialog.DialogFooter className="!px-6" data-sentry-element="unknown" data-sentry-source-file="ConfirmDialog.tsx">
          <div className="flex gap-2">
            {!shouldHideCancelButton && <Button className="flex-1" intent="neutral" size="md" variant="contained" onClick={onClose}>
                {cancelText}
              </Button>}
            <Button disabled={isLoading} className="flex-1 gap-2" intent="strong" size="md" variant="contained" onClick={async () => {
            if (onConfirm != null) {
              await startLoading(onConfirm());
            }
          }} data-sentry-element="Button" data-sentry-source-file="ConfirmDialog.tsx">
              <>
                {isLoading && <LoadingSpinner className="size-4" />}
                {confirmText}
              </>
            </Button>
          </div>
        </ZDialog.DialogFooter>
      </ZDialog.DialogPanel>
    </ZDialog.Dialog>;
}